<template>
  <Legacy
    view="edi"
    action="connote"
  />
</template>

<script>
import Legacy from '@/components/Application/Legacy'

export default {
  components: {
    Legacy
  },
  data () {
    return {
      breadcrumb: {
        name: 'Consignments',
        route: { name: 'freight-consignments' }
      }
    }
  }
}
</script>
